import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-visualizar-requisitar-cartoes',
  templateUrl: './modal-visualizar-requisitar-cartoes.component.html',
  styleUrls: ['./modal-visualizar-requisitar-cartoes.component.scss']
})
export class ModalVisualizarRequisitarCartoesComponent implements OnInit {

  @Input() text: string;

  @ViewChild("card", null)

  private card: ElementRef;


  constructor(
    protected ref: NbDialogRef<ModalVisualizarRequisitarCartoesComponent>
    ) {



    }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();

  }

  dismiss() {
    this.ref.close();
  }

}
